const ALLOWED_TAGS = new Set([
  'P', 'H2', 'H3', 'H4', 'STRONG', 'B', 'EM', 'I', 'U',
  'UL', 'OL', 'LI', 'BLOCKQUOTE', 'A', 'BR', 'HR'
]);

const BLOCKED_TAGS = new Set([
  'SCRIPT', 'STYLE', 'IFRAME', 'OBJECT', 'EMBED', 'FORM', 'INPUT',
  'BUTTON', 'TEXTAREA', 'SELECT', 'OPTION', 'SVG', 'MATH'
]);

const safeLink = (href) => {
  const value = String(href || '').trim();
  if (!value) return '';
  if (value.startsWith('/') || value.startsWith('#')) return value;
  try {
    const parsed = new URL(value, window.location.origin);
    return ['http:', 'https:', 'mailto:', 'tel:'].includes(parsed.protocol) ? value : '';
  } catch {
    return '';
  }
};

export function sanitizeProductHtml(value = '') {
  if (typeof window === 'undefined' || typeof DOMParser === 'undefined') return String(value || '');
  const doc = new DOMParser().parseFromString(`<div id="product-html-root">${String(value || '')}</div>`, 'text/html');
  const root = doc.getElementById('product-html-root');
  if (!root) return '';

  const cleanNode = (node) => {
    Array.from(node.childNodes).forEach((child) => {
      if (child.nodeType !== Node.ELEMENT_NODE) return;
      const element = child;
      const tag = element.tagName.toUpperCase();

      if (BLOCKED_TAGS.has(tag)) {
        element.remove();
        return;
      }

      if (!ALLOWED_TAGS.has(tag)) {
        element.replaceWith(...Array.from(element.childNodes));
        cleanNode(node);
        return;
      }

      const originalHref = tag === 'A' ? element.getAttribute('href') || '' : '';
      const originalTarget = tag === 'A' ? element.getAttribute('target') || '' : '';
      const originalTitle = tag === 'A' ? element.getAttribute('title') || '' : '';
      Array.from(element.attributes).forEach((attribute) => element.removeAttribute(attribute.name));
      if (tag === 'A') {
        const href = safeLink(originalHref);
        if (href) element.setAttribute('href', href);
        if (originalTitle) element.setAttribute('title', originalTitle);
        if (originalTarget === '_blank') {
          element.setAttribute('target', '_blank');
          element.setAttribute('rel', 'noopener noreferrer');
        }
      }
      cleanNode(element);
    });
  };

  cleanNode(root);
  return root.innerHTML.trim();
}

export function productHtmlToPlainText(value = '') {
  if (typeof window === 'undefined' || typeof DOMParser === 'undefined') {
    return String(value || '').replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
  }
  const doc = new DOMParser().parseFromString(String(value || ''), 'text/html');
  doc.querySelectorAll('script,style,iframe,object,embed,form,svg,math').forEach((node) => node.remove());
  return (doc.body.textContent || '').replace(/\s+/g, ' ').trim();
}
